<template>
	<div>
		<el-row style="background-color: lightgray;margin-bottom: 20px;padding-left: 30px;">全部{{totalResultCount}}条浏览记录</el-row>
		<el-row v-for="(item,index) in resultDataList" style="padding: 10px;">
			<el-row>
				<el-col :span="24">
					<el-row>
						<router-link :to="{ name: 'detail', params: { id: item.id }}" style="font-weight: bold;">
							{{item.title}}</router-link>
					</el-row>
					<el-row>
						{{item.updatetime?item.updatetime.substring(0,10):''}}
					</el-row>
				</el-col>
			</el-row>
			<!-- <el-row>
				<el-divider></el-divider>
			</el-row> -->
		</el-row>
		<el-row class="pagediv">
			<el-pagination @size-change="changePageSize" @current-change="changeSearchPage" :current-page="pageNum"
				:page-sizes="[10, 15, 20]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
				:total="totalResultCount">
			</el-pagination>
		</el-row>
		<div class="m_b1"></div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {
			this.getHistoryfnc();
		},
		methods: {
			getHistoryfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/GetUserRecord',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = parseInt(response.data.data.data.totalcount);
						_this.loadingMask = false;
						_this.$emit('senddata',_this.totalResultCount);
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getHistoryfnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.getHistoryfnc();
			},
		},
	}
</script>

<style>
</style>
